import { css, keyframes } from 'styled-components';
import { skeletonGradient, skeletonGradientLighter } from '../tokens';
var loading = /*#__PURE__*/keyframes(["from{transform:translateX(0);}to{transform:translateX(100vw);}"]);
export var applySkeletonGradient = function applySkeletonGradient(_ref) {
  var lighter = _ref.lighter;
  return css(["position:relative;overflow:hidden;z-index:1;&::before{content:'';position:absolute;animation:", " 4s linear infinite;background-image:", ";top:0;left:-100vw;width:200vw;height:100%;}"], loading, lighter ? skeletonGradientLighter : skeletonGradient);
};